/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { IntegrationCredentialModelDto } from '../models/integration-credential-model-dto';
import { integrationsControllerDeleteIntegration } from '../fn/integrations/integrations-controller-delete-integration';
import { IntegrationsControllerDeleteIntegration$Params } from '../fn/integrations/integrations-controller-delete-integration';
import { integrationsControllerGetIntegrations } from '../fn/integrations/integrations-controller-get-integrations';
import { IntegrationsControllerGetIntegrations$Params } from '../fn/integrations/integrations-controller-get-integrations';
import { integrationsControllerGetStreams } from '../fn/integrations/integrations-controller-get-streams';
import { IntegrationsControllerGetStreams$Params } from '../fn/integrations/integrations-controller-get-streams';
import { integrationsControllerTestIntegration } from '../fn/integrations/integrations-controller-test-integration';
import { IntegrationsControllerTestIntegration$Params } from '../fn/integrations/integrations-controller-test-integration';
import { integrationsControllerUpsertIntegration } from '../fn/integrations/integrations-controller-upsert-integration';
import { IntegrationsControllerUpsertIntegration$Params } from '../fn/integrations/integrations-controller-upsert-integration';
import { IntegrationTestResultDto } from '../models/integration-test-result-dto';
import { StreamListModelDto } from '../models/stream-list-model-dto';

@Injectable({ providedIn: 'root' })
export class IntegrationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `integrationsControllerGetIntegrations()` */
  static readonly IntegrationsControllerGetIntegrationsPath = '/integrations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `integrationsControllerGetIntegrations()` instead.
   *
   * This method doesn't expect any request body.
   */
  integrationsControllerGetIntegrations$Response(params?: IntegrationsControllerGetIntegrations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<IntegrationCredentialModelDto>>> {
    return integrationsControllerGetIntegrations(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `integrationsControllerGetIntegrations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  integrationsControllerGetIntegrations(params?: IntegrationsControllerGetIntegrations$Params, context?: HttpContext): Observable<Array<IntegrationCredentialModelDto>> {
    return this.integrationsControllerGetIntegrations$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<IntegrationCredentialModelDto>>): Array<IntegrationCredentialModelDto> => r.body)
    );
  }

  /** Path part for operation `integrationsControllerGetStreams()` */
  static readonly IntegrationsControllerGetStreamsPath = '/integrations/streams';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `integrationsControllerGetStreams()` instead.
   *
   * This method doesn't expect any request body.
   */
  integrationsControllerGetStreams$Response(params?: IntegrationsControllerGetStreams$Params, context?: HttpContext): Observable<StrictHttpResponse<StreamListModelDto>> {
    return integrationsControllerGetStreams(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `integrationsControllerGetStreams$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  integrationsControllerGetStreams(params?: IntegrationsControllerGetStreams$Params, context?: HttpContext): Observable<StreamListModelDto> {
    return this.integrationsControllerGetStreams$Response(params, context).pipe(
      map((r: StrictHttpResponse<StreamListModelDto>): StreamListModelDto => r.body)
    );
  }

  /** Path part for operation `integrationsControllerUpsertIntegration()` */
  static readonly IntegrationsControllerUpsertIntegrationPath = '/integrations/{provider}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `integrationsControllerUpsertIntegration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  integrationsControllerUpsertIntegration$Response(params: IntegrationsControllerUpsertIntegration$Params, context?: HttpContext): Observable<StrictHttpResponse<IntegrationCredentialModelDto>> {
    return integrationsControllerUpsertIntegration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `integrationsControllerUpsertIntegration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  integrationsControllerUpsertIntegration(params: IntegrationsControllerUpsertIntegration$Params, context?: HttpContext): Observable<IntegrationCredentialModelDto> {
    return this.integrationsControllerUpsertIntegration$Response(params, context).pipe(
      map((r: StrictHttpResponse<IntegrationCredentialModelDto>): IntegrationCredentialModelDto => r.body)
    );
  }

  /** Path part for operation `integrationsControllerDeleteIntegration()` */
  static readonly IntegrationsControllerDeleteIntegrationPath = '/integrations/{provider}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `integrationsControllerDeleteIntegration()` instead.
   *
   * This method doesn't expect any request body.
   */
  integrationsControllerDeleteIntegration$Response(params: IntegrationsControllerDeleteIntegration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return integrationsControllerDeleteIntegration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `integrationsControllerDeleteIntegration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  integrationsControllerDeleteIntegration(params: IntegrationsControllerDeleteIntegration$Params, context?: HttpContext): Observable<void> {
    return this.integrationsControllerDeleteIntegration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `integrationsControllerTestIntegration()` */
  static readonly IntegrationsControllerTestIntegrationPath = '/integrations/{provider}/test';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `integrationsControllerTestIntegration()` instead.
   *
   * This method doesn't expect any request body.
   */
  integrationsControllerTestIntegration$Response(params: IntegrationsControllerTestIntegration$Params, context?: HttpContext): Observable<StrictHttpResponse<IntegrationTestResultDto>> {
    return integrationsControllerTestIntegration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `integrationsControllerTestIntegration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  integrationsControllerTestIntegration(params: IntegrationsControllerTestIntegration$Params, context?: HttpContext): Observable<IntegrationTestResultDto> {
    return this.integrationsControllerTestIntegration$Response(params, context).pipe(
      map((r: StrictHttpResponse<IntegrationTestResultDto>): IntegrationTestResultDto => r.body)
    );
  }

}
